import { Injectable } from '@angular/core';
import { CatalogSearchResultModel, CatalogSearchSuggestionsResultModel, ProductModel, SearchInputModel } from '@libs/shop/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({ providedIn: 'root' })
export class CatalogSearchRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public search(params: SearchInputModel): Observable<CatalogSearchResultModel> {
    return this.connector.connect('shop', 'catalogSearch', {
      searchParams: {
        ...params,
      },
    });
  }

  public getSuggestions(searchText: string): Observable<CatalogSearchSuggestionsResultModel> {
    return this.connector.connect('shop', 'catalogSearchSuggestions', {
      pathParams: {
        q: encodeURIComponent(searchText),
      },
    });
  }

  public findProductsBySkus(skus: string[]): Observable<ProductModel[]> {
    return this.connector.connect('shop', 'findProductsBySkus', {
      searchParams: {
        skus,
      },
    });
  }
}
